module.exports = __webpack_public_path__ + "img/icon-tracking-truck.b417109a.svg";